<div class="existing-contract">
  <div>
    <h2>{{ 'NEW_CONTRACTS.DRAFT_DIALOG.TITLE' | i18nextEager }}</h2>
  </div>
  <span class="text">{{ 'NEW_CONTRACTS.CONTINUE_SIGNATURE' | i18nextEager }}</span>
  <div class="buttons">
    <button class="secondary" (click)="closeDialog('exit')">{{ 'COMMONS.EXIT' | i18nextEager }}</button>
    <button (click)="closeDialog('next')">{{ 'COMMONS.CONTINUE' | i18nextEager }}</button>
  </div>
</div>
